var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48773 7.31343L14.7398 1.06133C14.9426 0.858576 15.1668 0.754851 15.4126 0.750153C15.6582 0.745455 15.8869 0.849181 16.0988 1.06133C16.3109 1.27323 16.417 1.49972 16.417 1.7408C16.417 1.98163 16.3068 2.2122 16.0865 2.43251L9.30369 9.21535C9.1813 9.32785 9.05272 9.41229 8.91796 9.46867C8.78321 9.52504 8.63732 9.55323 8.48031 9.55323C8.32355 9.55323 8.17779 9.52504 8.04303 9.46867C7.90803 9.41229 7.78428 9.32785 7.67177 9.21535L0.888936 2.43251C0.678023 2.2216 0.576397 1.99943 0.584062 1.76602C0.59148 1.53261 0.701141 1.30983 0.913043 1.09768C1.12494 0.885774 1.35144 0.779822 1.59251 0.779823C1.83359 0.779823 2.06008 0.885774 2.27198 1.09768L8.48773 7.31343Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2963960d86c3ca767052fde415b1f663.svg";
export { ForwardRef as ReactComponent };